import styled from 'styled-components';
import Theme from '../../../Theme';

type Props = {
  selected: boolean
  number?: string
}

const Container = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  user-select: none;
  z-index: 1;
  height: 12px;

  h1 {
    font-size: 18px;
    font-weight: 700;
    line-height: 1;
    letter-spacing: 0.2px;
    color: ${Theme.colors.BrandOrange};
    margin-right: 7px;
  }

  .line {
    height: 1px;
    background-color: white;
    transition: all 0.2s ease-in-out;

    ${({ selected }: Props) => {
      if (selected) {
        return`
          min-width: 4vw;
          max-width: 4vw;
        `;
      } else {
        return`
          min-width: 3vw;
          max-width: 3vw;
        `;
      }
    }}
  }
`;

const Chapter = ({ selected, number }: Props) => {
  return(
    <Container selected={selected}>
      { selected && <h1>{ number }</h1> }
      <div className='line' />
    </Container>
  );
};

export default Chapter;